var _a, _Upgrade_id;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { makeStore } from '../customStore';
import { resource } from './resources';
import { get } from 'svelte/store';
class Upgrade {
    constructor(resource, cost, costMultiplier, maxBuy = null, bought = 0) {
        var _b, _c, _d;
        this.resource = resource;
        this.cost = cost;
        this.costMultiplier = costMultiplier;
        this.maxBuy = maxBuy;
        this.bought = bought;
        this.id = (__classPrivateFieldSet(_b = Upgrade, _a, (_d = __classPrivateFieldGet(_b, _a, "f", _Upgrade_id), _c = _d++, _d), "f", _Upgrade_id), _c);
    }
}
_a = Upgrade;
_Upgrade_id = { value: 0 };
export const upgradesInitial = {
    // Cogito Ergo Sum
    thoughtAcceleration: new Upgrade('thoughts', 10, 1.15),
    thoughtJerk: new Upgrade('thoughts', 1e8, 1.3),
    thoughtBoostStrength: new Upgrade('thoughts', 100, 2),
    thoughtBoostDuration: new Upgrade('thoughts', 150, 4, 11),
    thoughtBoostStack: new Upgrade('thoughts', 1e7, 5, 9),
    // Switzerland Simulator
    cheeseQueueLength: new Upgrade('cheese', 5, 2),
    cheeseYield: new Upgrade('cheese', 15, 1.3),
    cheeseThoughtMult: new Upgrade('cheese', 300, 2),
    cheeseQueueOverclockingCost: new Upgrade('cheese', 5e3, 1.5),
    // Moldy Cheese
    moldyCheeseConversionExponent: new Upgrade('moldyCheese', 5, 1.5),
    moldyCheeseHalfLife: new Upgrade('moldyCheese', 20, 1.3),
    moldyCheeseChance: new Upgrade('moldyCheese', 200, 2.5, 9),
    cheeseMonsterSpawnrate: new Upgrade('moldyCheese', 250, 2.0),
    cheeseMonsterCapacity: new Upgrade('moldyCheese', 500, 1.3),
    // Loot
    cheeseMonsterDropRate: new Upgrade('cheeseBrains', 5, 2, 18),
    cheeseMonsterLoot: new Upgrade('cheeseBrains', 10, 1.15),
    cheeseMonsterSentience: new Upgrade('cheeseBrains', 20, 1.2),
    cheeseMonsterMoldiness: new Upgrade('cheeseBrains', 100, 1.25),
    // Milk Power
    milkPowerGain: new Upgrade('milkPower', 100, 2),
    cheeseMonsterCapacityPerUpgrade: new Upgrade('milkPower', 1000, 1.5),
    // Milk
    milkThoughtsGain: new Upgrade('milk', 10, 1.5),
    milkCheeseGain: new Upgrade('milk', 10, 1.5),
    milkMoldyCheeseGain: new Upgrade('milk', 10, 1.5),
    milkMonsterGain: new Upgrade('milk', 10, 1.5),
};
export const upgrades = makeStore(upgradesInitial);
function makeUpgradesStore(initialState) {
    const store = makeStore(initialState);
    const buy = (name, buyMaxUpgrades = false) => {
        store.update($store => {
            const upgrade = $store[name];
            let checkoutCost = 0;
            const res = get(resource)[upgrade.resource];
            if (res < upgrade.cost)
                return $store;
            if (!buyMaxUpgrades) {
                // PURCHASE SINGLE:
                checkoutCost = upgrade.cost;
                upgrade.cost *= upgrade.costMultiplier;
                upgrade.bought++;
            }
            else {
                // PURCHASE MAX:
                const cost = upgrade.cost;
                const costMult = upgrade.costMultiplier;
                // used formulas for geometric series (because of the exponential cost curve of the upgrades)
                const numUpgradesAffordable = Math.floor(Math.log((res / cost) * (costMult - 1) + 1) / Math.log(costMult));
                const totalPrice = (cost * (Math.pow(costMult, numUpgradesAffordable) - 1)) / (costMult - 1);
                checkoutCost = totalPrice;
                upgrade.cost *= Math.pow(costMult, numUpgradesAffordable);
                upgrade.bought += numUpgradesAffordable;
                // alert("Upgrades affordable: " + numUpgradesAffordable + ", Total Prize: " + totalPrice)
            }
            resource.update($resource => {
                $resource[upgrade.resource] -= checkoutCost;
                return $resource;
            });
            return $store;
        });
    };
    return Object.assign(Object.assign({}, store), { buy });
}
